import requests from "./httpService";

const QuoteServices = {
  getAll: async (body) => {
    return requests.get("/admin/quotes/get_all", body);
  },
  getAllQuote: async (body) => {
    return requests.get("/admin/quotes/", body);
  },
  getAllAdminQuote: async (body) => {
    return requests.get("/admin/quotes/admin_quotes/", body);
  },
  getQuoteById: async (id, body) => {
    return requests.get(`/admin/quotes/quote/${id}`, body);
  },
  getAdminQuoteById: async (id, body) => {
    return requests.get(`/admin/quotes/admin_quote/${id}`, body);
  },
  getAdminQuoteRowsById: async (id, body) => {
    return requests.get(`/admin/quotes/admin_quote_rows/${id}`, body);
  },
  deleteQuote: async (id) => {
    return requests.delete(`/admin/quotes/delete/${id}`);
  },
  deleteAdminQuote: async (id) => {
    return requests.delete(`/admin/quotes/delete_quote/${id}`);
  },
  updateQuote: async (id, body) => {
    return requests.put(`/admin/quotes/update/${id}`, body);
  },
  updateAdminQuote: async (id, body) => {
    return requests.put(`/admin/quotes/update_quote/${id}`, body);
  },
  updateAdminQuoteTotal: async (id, body) => {
    return requests.put(`/admin/quotes/update_quote_admin/${id}`, body);
  },
  searchQuote: async (query, status) => {
    return requests.get(`/admin/quotes/search_quote?q=${query}&status=${status}`);
  },
  searchAdminQuote: async (query, status) => {
    return requests.get(`/admin/quotes/search_admin_quote?q=${query}&status=${status}`);
  },
  sendMail: async (body) => {
    return requests.post("admin/quotes_messages/store", body);
  },
  addQuote: async (body) => {
    return requests.post("/admin/quotes/save_quote", body);
  },
};

export default QuoteServices;
